import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context';
import ChatWindow from '../components/ChatWindow';
import SupportModal from '../components/SupportModal';

const DOMAIN_LABEL = {
  all: 'All domains',
  people: 'People',
  process: 'Process',
  'business-environment': 'Business Environment',
};

export default function Dashboard() {
  const { user } = useAuth();
  const [support, setSupport] = useState(false);

  return (
    <div className="container" style={{ marginTop: 28, marginBottom: 40 }}>
      <div className="row-between wrap" style={{ marginBottom: 18 }}>
        <div>
          <h1>Hi, {user.fullName.split(' ')[0]} 👋</h1>
          <p className="muted small">
            Study focus: <b>{DOMAIN_LABEL[user.focusDomain] || 'All domains'}</b>
            {user.targetExamDate ? ` · Target exam: ${user.targetExamDate}` : ''}
          </p>
        </div>
        <div className="row wrap">
          <Link to="/mock-exams" className="btn btn-ghost btn-sm">Mock exams</Link>
          <Link to="/progress" className="btn btn-ghost btn-sm">Progress</Link>
          <button className="btn btn-ghost btn-sm" onClick={() => setSupport(true)}>Help</button>
        </div>
      </div>

      <ChatWindow />

      <SupportModal open={support} onClose={() => setSupport(false)} />
    </div>
  );
}
